import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/full/form/",
)({
	component: OrgRecordTypeFullFormBuilderRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; recordTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				recordTypeId: z.string().parse(p.recordTypeId),
			};
		},
	},
});

function OrgRecordTypeFullFormBuilderRoute() {
	return (
		<div className="flex min-h-0 flex-1 flex-col px-4">
			<FormBuilderPanel />
		</div>
	);
}
